import { AES, enc } from "crypto-js";

export const SECRET_KEY = 'secret-key';

export const encryptData = (data, secretKey) => {
    const encryptedData = AES.encrypt(JSON.stringify(data), secretKey).toString();
    return encryptedData;
}

export const decryptData = (encryptedData, secretKey) => {

    const decryptedData = AES.decrypt(encryptedData, secretKey).toString(enc.Utf8);
    if (decryptedData) {
        try {
            return JSON.parse(decryptedData);
        } catch (error) {
            console.error("Error parsing JSON:", error);
        }

    } else {
        console.error("Empty decrypted data");
    }
}